import { render, staticRenderFns } from "./Evidencia.vue?vue&type=template&id=2c44c749&scoped=true"
import script from "./Evidencia.vue?vue&type=script&lang=js"
export * from "./Evidencia.vue?vue&type=script&lang=js"
import style0 from "./Evidencia.vue?vue&type=style&index=0&id=2c44c749&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c44c749",
  null
  
)

export default component.exports